import { DMS_MODULE } from './constants';
import { router } from './router';
import { menu } from './menu';

export const OjeteVozy = {
	name: DMS_MODULE,
	router,
	menu,
};
